import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { Breadcrumb } from '../../../../../shared/components/Breadcrumb/Breadcrumb'
import { SkipButton } from '../../../../../shared/components/SkipButton/SkipButton'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import styles from './ReviewsBreadcrumb.module.scss'

export const ReviewsBreadcrumb: FunctionComponent = () => {
  const { state } = useContext(ReviewsTemplateContext)

  const { breadcrumb, needsBasedFilters } = state.productListingPageData

  return (
    <>
      <SkipButton
        className={styles.reviewsBreadcrumbSkipButton}
        selector={
          !!needsBasedFilters?.length
            ? 'label[data-testid="answer-radio"]'
            : 'button[data-testid="accordion-item-button"]'
        }
      >
        Skip to Filters
      </SkipButton>
      <SkipButton
        className={styles.reviewsBreadcrumbSkipButton}
        selector='article[data-testid="sb-product-card"]'
      >
        Skip to Products
      </SkipButton>
      <Breadcrumb {...breadcrumb} data-testid="breadcrumb" />
    </>
  )
}
